


export class CostReviewSecurityEnUsAccessControlSystems {
  isAccessSystemChecked!: boolean;
  integrationWithOtherSystems!: number;
  isNewVendorChecked!: boolean;
  newVendor!: string;
  isReplacementVendorChecked!: boolean;
  replacementVendor!: string;
  isExpansionVendorChecked!: boolean;
  expansionVendor!: string;
  detailedDrawings!: number;
  firmElectricalQuote!: number;
  networkProvidedBy!: number;
  serverProvidedBy!: number;
  clientComputer!: number;
  numberOfClients!: number;
  risk!: string;
  numberOfPanels!: number;
  numberOfReaders!: number;
  numberOfContacts!: number;
  numberOfREX!: number;
  doorHardwareType!: number[];
  doorHardwareProvidedBy!: number;
  doorHardwareInstalledBy!: number;
  numberOfDoors!: number;
  localDoorAlarms!: number;
  employeesToTrain!: number;
  lowContractor!: string;
  numberOfBidders!: number;
  wireSpend!: number;
  thirdPartyCommodity!: number;
}
